import {Component, Inject, Input, OnInit, Optional, QueryList, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {EnumLoginViewMode, ICRUDCommand, ICRUDRecord, IPreferenceKeys, IPreferencesBusiness, IUser} from "../../../interfaces";
import {actionPreferenceUpdateStore, actionTwoFactorAuth, actionTwoFactorAuthError, actionTwoFactorAuthReply, actionTwoFactorGen, actionTwoFactorGenReply} from "../../../store/actions/user.actions";
import {ToastrService} from "ngx-toastr";
import {AppService, LocalStoreService, StoreSelectorsService, UserService} from "../../../services";
import {isNullOrUndefOrEmpty, validateEmail} from "../../../common";
import {Compbaser} from "../../../components/compbaser";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Lib} from "../../../../libs/Lib";
import {ActionsSubject} from "@ngrx/store";
import {ofType} from "@ngrx/effects";
import {MatInput} from "@angular/material/input";

@Component({
    selector: 'app-two-factor',
    templateUrl: './two-factor.component.html',
    styleUrls: ['./two-factor.component.scss'],
    standalone: false
})
export class TwoFactorComponent extends Compbaser implements OnInit {
    m_viewMod = EnumLoginViewMode;
    m_name = '';
    m_user: IUser;
    preferences: IPreferencesBusiness = {};
    m_preFill = false;
    m_disableInput = false;
    m_twoFactorState = false;
    twoFactorQrCode = '';
    serverToken = '';
    userToken = '';
    dialogRef;
    lockMode = false;
    inputControls = Array(6).fill(null);
    inputValues = ['', '', '', '', '', ''];
    inputValuesReady = false;


    @ViewChildren('inputBox') inputBoxes!: QueryList<MatInput>;

    @ViewChild("twoFactorModalEnable", {read: TemplateRef}) twoFactorModalEnable: TemplateRef<any>;
    @ViewChild("twoFactorModalDisable", {read: TemplateRef}) twoFactorModalDisable: TemplateRef<any>;
    @Input() hideBack = false;

    @Input()
    set userLoggedIn(i_enable: boolean) {
        if (!i_enable) return;
        this.m_preFill = true;
    }

    constructor(dialog: MatDialog,
                @Optional() @Inject(MAT_DIALOG_DATA) data,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private appService: AppService,
                private actionsSubj: ActionsSubject,
                private localStoreService: LocalStoreService,
                private storeSelector: StoreSelectorsService,
                private userService: UserService,
                @Optional() @Inject(MatDialogRef) public localDialogRef?: MatDialogRef<TwoFactorComponent>) {
        super(dialog);
        if (data) {
            this.lockMode = true;
        }
    }

    ngOnInit() {
        this.cod(
            this.actionsSubj.pipe(ofType(actionTwoFactorGenReply))
                .subscribe((payload: any) => {
                    this.twoFactorQrCode = payload.replay.value;
                    this.serverToken = payload.replay.token;
                    this.openQrDialog();
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionTwoFactorAuthReply))
                .subscribe((payload: any) => {
                    // failed, do nothing...
                    if (!payload.replay.status) {
                        this.toastr.warning(this.translocoService.translate('toast.twoFactorFailed', {}, this.translocoService.getActiveLang()));
                        return;
                    }
                    // pass, check mode
                    if (payload.replay.action === 'check') {
                        this.onClose();
                        this.toastr.info(this.translocoService.translate('toast.twoFactorActive', {}, this.translocoService.getActiveLang()));
                        return;
                    }
                    // pass, disable mode
                    if (payload.replay.action === 'disable') {
                        this.onClose();
                        this.toastr.info(this.translocoService.translate('toast.twoFactorRemoved', {}, this.translocoService.getActiveLang()));
                        this.m_twoFactorState = false;
                        this.storeSelector.dispatch(actionPreferenceUpdateStore({
                            preferencesBusiness: {
                                twoFactorState: {
                                    value: {
                                        status: false,
                                        token: ''
                                    }
                                }
                            }
                        }));
                        return;
                    }
                    // pass, added new mode
                    this.onClose();
                    this.toastr.info(this.translocoService.translate('toast.twoFactorActive', {}, this.translocoService.getActiveLang()));
                    this.m_twoFactorState = true;
                    const controlName: IPreferenceKeys = 'twoFactorState';
                    const prefValue = {
                        value: {
                            status: true,
                            token: payload.replay.token,
                            user: this.m_user.username.toLowerCase()
                        }
                    };

                    if (this.m_user.dashboard) {
                        // Reseller/enterprise: save via mars /savePreference endpoint
                        this.userService.savePreferenceViaNode({
                            preference_key: controlName,
                            preference_value: prefValue,
                            user_id: Lib.Base64().encode(this.m_user.username.toLowerCase())
                        }).subscribe((reply: any) => {
                            if (!reply?.status) return;
                            const data = {};
                            data[controlName] = {
                                id: this.preferences[controlName]?.id || reply.id,
                                value: prefValue.value
                            };
                            this.storeSelector.dispatch(actionPreferenceUpdateStore({
                                preferencesBusiness: data
                            }));
                        });
                    } else {
                        // End user: save via IIS crudRecord
                        const command: ICRUDCommand = this.preferences[controlName] ? 'update' : 'add';
                        const saveRecord: ICRUDRecord = {
                            studioId: this.localStoreService.getStorageConfig().studioId,
                            command,
                            primary: 'preference_id',
                            table: 'preferences',
                            id: command === 'update' ? this.preferences[controlName].id : null,
                            body: {
                                user_id: Lib.Base64().encode(this.m_user.username.toLowerCase()),
                                preference_key: controlName,
                                preference_value: prefValue,
                            }
                        };
                        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                            if (!i_crudReply.serverReply.status) return;
                            const data = {};
                            data[controlName] = {
                                id: command === 'update' ? this.preferences[controlName].id : i_crudReply.serverReply.id,
                                value: prefValue.value
                            };
                            this.storeSelector.dispatch(actionPreferenceUpdateStore({
                                preferencesBusiness: data
                            }));
                        });
                    }
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionTwoFactorAuthError))
                .subscribe((payload: any) => {
                    this.toastr.error(this.translocoService.translate('toast.twoFactorError', {}, this.translocoService.getActiveLang()));
                })
        );
        this.cod(
            this.storeSelector.getPreferences()
                .subscribe((i_preferences) => {
                    this.m_twoFactorState = false;
                    if (isNullOrUndefOrEmpty(i_preferences))
                        return;
                    this.preferences = i_preferences;
                    if (i_preferences?.twoFactorState?.value) {
                        this.m_twoFactorState = i_preferences.twoFactorState.value.status;
                    }
                })
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    if (!i_user || isNullOrUndefOrEmpty(i_user.username))
                        return;
                    this.m_user = i_user;
                    if (this.m_preFill) {
                        if (validateEmail(this.m_user.email)) {
                            this.m_name = this.m_user.email;
                            this.m_disableInput = true;
                        } else if (validateEmail(this.m_user.username)) {
                            this.m_name = this.m_user.username.toLowerCase();
                            this.m_disableInput = true;
                        }
                    }
                })
        );
    }

    openQrDialog(): void {
        this.clearSelection();
        if (this.m_twoFactorState){
            this.dialogRef = this.dialog.open(this.twoFactorModalEnable, {
                width: '400px',
            });
        } else {
            this.dialogRef = this.dialog.open(this.twoFactorModalDisable, {
                width: '400px',
                disableClose: true
            });
        }
    }

    enableTwoFactor() {
        this.userToken = this.inputValues.join('');
        this.storeSelector.dispatch(actionTwoFactorAuth({
            payload: {
                mode: 'enable',
                userToken: this.userToken,
                serverToken: this.serverToken,
                userName: this.m_user.username.toLowerCase()
            }
        }));
    }

    disableTwoFactor() {
        this.userToken = this.inputValues.join('');
        this.storeSelector.dispatch(actionTwoFactorAuth({
            payload: {
                mode: 'disable',
                userToken: this.userToken,
                serverToken: null,
                userName: this.m_user.username.toLowerCase()
            }
        }));
    }

    checkTwoFactor() {
        this.userToken = this.inputValues.join('');
        this.storeSelector.dispatch(actionTwoFactorAuth({
            payload: {
                mode: 'check',
                userToken: this.userToken,
                serverToken: null,
                userName: this.m_user.username.toLowerCase()
            }
        }));
    }

    onClose() {
        if (this.localDialogRef)
            this.localDialogRef.close();
        if (this.dialogRef)
            this.dialogRef.close();
    }

    onTwoFactorAuthentication() {
        this.storeSelector.dispatch(actionTwoFactorGen({payload: null}));
    }

    clearSelection() {
        this.userToken = '';
        this.inputControls = Array(6).fill(null);
        this.inputValues = ['', '', '', '', '', ''];
    }

    onInput(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        this.inputValues[index] = input.value;

        if (input.value.length === 1) {
            if (index < this.inputValues.length - 1) {
                const nextInput = this.inputBoxes.toArray()[index + 1]['nativeElement'] as HTMLInputElement;
                nextInput.focus();
            } else if (index === this.inputValues.length - 1) {
                // If the last input box is filled, show the success alert
                // alert('Success! All inputs are filled.');
            }
        }
        this.inputValuesReady = this.inputValues.every(value => /^[0-9]$/.test(value));
    }

    onBackspace(event: Event, index: number): void {
        if (index > 0 && this.inputValues[index] === '') {
            const prevInput = this.inputBoxes.toArray()[index - 1]['nativeElement'] as HTMLInputElement;
            prevInput.focus();
        }
    }

    clearInputs(): void {
        this.inputValues = ['', '', '', '', '', ''];
        const firstInput = this.inputBoxes.first['nativeElement'] as HTMLInputElement;
        firstInput.focus();
    }

}


